var map = {
	"./alerts.png": "2bde",
	"./alerts_big.png": "ad12",
	"./assetManagement/asset_anchor.png": "985f",
	"./assetManagement/asset_bed.png": "3a4a",
	"./assetManagement/asset_chart.png": "ff6f",
	"./assetManagement/asset_circle.png": "1ac1",
	"./assetManagement/asset_cog.png": "c821",
	"./assetManagement/asset_cubes.png": "c2fa",
	"./assetManagement/asset_database.png": "7583",
	"./assetManagement/asset_dumpster_fire.png": "01f2",
	"./assetManagement/asset_factory.png": "ac52",
	"./assetManagement/asset_fire.png": "cd4f",
	"./assetManagement/asset_institution.png": "8022",
	"./assetManagement/asset_mining.png": "9843",
	"./assetManagement/asset_office.png": "c2bb",
	"./assetManagement/asset_offshorerig.png": "ec5f",
	"./assetManagement/asset_oilrig.png": "dafa",
	"./assetManagement/asset_plane.png": "ff7f",
	"./assetManagement/asset_plug.png": "7dd7",
	"./assetManagement/asset_plus.png": "5b24",
	"./assetManagement/asset_shield.png": "ae14",
	"./assetManagement/asset_square.png": "cebc",
	"./assetManagement/asset_star.png": "dca1",
	"./assetManagement/asset_target.png": "a5dd",
	"./assetManagement/asset_train.png": "fb43",
	"./assetManagement/asset_warning.png": "e070",
	"./chevron_black_mapping.png": "5369",
	"./chevron_black_menu.png": "4405",
	"./chevron_white_mapping.png": "d8da",
	"./chevron_white_menu.png": "c7ae",
	"./conflict.png": "8ec5",
	"./conflict_white.png": "f7d8",
	"./controlRisksIncidents/depricated/maritime-black.png": "a017",
	"./controlRisksIncidents/depricated/maritime-blue.png": "fcea",
	"./controlRisksIncidents/depricated/maritime.png": "c263",
	"./controlRisksIncidents/depricated/political-black.png": "6ee4",
	"./controlRisksIncidents/depricated/political-blue.png": "fb8a",
	"./controlRisksIncidents/incidents.png": "9d78",
	"./controlRisksIncidents/incidents_black.png": "21be8",
	"./controlRisksIncidents/incidents_blue.png": "0000",
	"./controlRisksIncidents/incidents_white.png": "d81dc",
	"./controlRisksIncidents/maritime-black.svg": "56c0",
	"./controlRisksIncidents/maritime-blue.svg": "2f87",
	"./controlRisksIncidents/maritime/big/Activism.svg": "3f87",
	"./controlRisksIncidents/maritime/big/Assault.svg": "05f4",
	"./controlRisksIncidents/maritime/big/Attempt.svg": "8161",
	"./controlRisksIncidents/maritime/big/Hijacking.svg": "a64f",
	"./controlRisksIncidents/maritime/big/Kidnapping.svg": "e41b",
	"./controlRisksIncidents/maritime/big/Maritime.svg": "2430",
	"./controlRisksIncidents/maritime/big/Robbery.svg": "0f7d",
	"./controlRisksIncidents/maritime/big/StateAction.svg": "e39a",
	"./controlRisksIncidents/maritime/big/Suspicious.svg": "78e5",
	"./controlRisksIncidents/maritime/big/Terrorism.svg": "7003",
	"./controlRisksIncidents/maritime/big/Theft.svg": "80d4",
	"./controlRisksIncidents/maritime/map/Activism.svg": "07b7",
	"./controlRisksIncidents/maritime/map/Assault.svg": "177f",
	"./controlRisksIncidents/maritime/map/Attempt.svg": "ff1e",
	"./controlRisksIncidents/maritime/map/Generic.svg": "8dfe",
	"./controlRisksIncidents/maritime/map/Hijacking.svg": "e0c9",
	"./controlRisksIncidents/maritime/map/Kidnapping.svg": "8d14",
	"./controlRisksIncidents/maritime/map/Robbery.svg": "e3d6",
	"./controlRisksIncidents/maritime/map/StateAction.svg": "404b",
	"./controlRisksIncidents/maritime/map/Suspicious.svg": "943f",
	"./controlRisksIncidents/maritime/map/Terrorism.svg": "ba81",
	"./controlRisksIncidents/maritime/map/Theft.svg": "2224",
	"./controlRisksIncidents/maritime/small/Activisim.svg": "4b6b",
	"./controlRisksIncidents/maritime/small/Assault.svg": "094a",
	"./controlRisksIncidents/maritime/small/Attempt.svg": "9bf6",
	"./controlRisksIncidents/maritime/small/Hijacking.svg": "7a14",
	"./controlRisksIncidents/maritime/small/Kidnapping.svg": "b062",
	"./controlRisksIncidents/maritime/small/Robbery.svg": "ecc6",
	"./controlRisksIncidents/maritime/small/StateAction.svg": "66ca",
	"./controlRisksIncidents/maritime/small/Suspicious.svg": "f173",
	"./controlRisksIncidents/maritime/small/Terrorism.svg": "5995",
	"./controlRisksIncidents/maritime/small/Theft.svg": "57f9",
	"./controlRisksIncidents/maritime/small/maritime.svg": "089b",
	"./controlRisksIncidents/sectors/Agriculture.svg": "7f2c",
	"./controlRisksIncidents/sectors/Aviation.svg": "ab2d",
	"./controlRisksIncidents/sectors/Construction.svg": "c26f",
	"./controlRisksIncidents/sectors/Education.svg": "4bc2",
	"./controlRisksIncidents/sectors/Entertainment.svg": "7f4d",
	"./controlRisksIncidents/sectors/Financial.svg": "1f43",
	"./controlRisksIncidents/sectors/Government.svg": "603c",
	"./controlRisksIncidents/sectors/Healthcare.svg": "7476",
	"./controlRisksIncidents/sectors/Hospitality.svg": "4c7c",
	"./controlRisksIncidents/sectors/InternationalInstitutions.svg": "a4ea",
	"./controlRisksIncidents/sectors/LawEnforcement.svg": "db23",
	"./controlRisksIncidents/sectors/Manufacturing.svg": "ebb9",
	"./controlRisksIncidents/sectors/Marine.svg": "3b7b",
	"./controlRisksIncidents/sectors/Media.svg": "e799",
	"./controlRisksIncidents/sectors/Military.svg": "25ba",
	"./controlRisksIncidents/sectors/Mining.svg": "635c",
	"./controlRisksIncidents/sectors/NGO.svg": "6f40",
	"./controlRisksIncidents/sectors/OilAndGas.svg": "ca69",
	"./controlRisksIncidents/sectors/Pharma.svg": "997d",
	"./controlRisksIncidents/sectors/Power.svg": "afec",
	"./controlRisksIncidents/sectors/PrivateProperty.svg": "8479",
	"./controlRisksIncidents/sectors/PublicPlace.svg": "a257",
	"./controlRisksIncidents/sectors/Rail.svg": "ec34",
	"./controlRisksIncidents/sectors/Religious.svg": "9162",
	"./controlRisksIncidents/sectors/Retail.svg": "7905",
	"./controlRisksIncidents/sectors/Road.svg": "8369",
	"./controlRisksIncidents/sectors/Telecommunications.svg": "e02e",
	"./controlRisksIncidents/sectors/Unknown.svg": "38e4",
	"./controlRisksIncidents/security-black.svg": "a8df",
	"./controlRisksIncidents/security-blue.svg": "03b9",
	"./controlRisksIncidents/security/big/Crime-white.svg": "24ca",
	"./controlRisksIncidents/security/big/Crime.svg": "b23f",
	"./controlRisksIncidents/security/big/Shield.svg": "4a80",
	"./controlRisksIncidents/security/big/Terrorism-white.svg": "ffa8",
	"./controlRisksIncidents/security/big/Terrorism.svg": "796a",
	"./controlRisksIncidents/security/big/Unrest-white.svg": "ef14",
	"./controlRisksIncidents/security/big/Unrest.svg": "5178",
	"./controlRisksIncidents/security/big/War-white.svg": "4a1c",
	"./controlRisksIncidents/security/big/War.svg": "f36e",
	"./controlRisksIncidents/security/map/Crime.svg": "81d0",
	"./controlRisksIncidents/security/map/Generic.svg": "c3e3",
	"./controlRisksIncidents/security/map/Terrorism.svg": "0c3f",
	"./controlRisksIncidents/security/map/Unrest.svg": "4b75",
	"./controlRisksIncidents/security/map/War.svg": "e678",
	"./controlRisksIncidents/security/small/Shield.svg": "eb44",
	"./controlRisksIncidents/security/small/political.svg": "a960",
	"./date_picker_black.png": "8652",
	"./date_picker_white.png": "e1a6",
	"./diplomacy_china_economic.png": "64d1",
	"./diplomacy_china_information.png": "df4c",
	"./diplomacy_china_infrastructure.png": "ed44",
	"./diplomacy_china_military.png": "453a",
	"./diplomacy_china_political.png": "9676",
	"./diplomacy_china_social.png": "10aa",
	"./disasters.png": "c5df",
	"./disasters_white.png": "cde0",
	"./earthquake.png": "65e7",
	"./events_activism_black.png": "6f92",
	"./events_activism_blue.png": "228b",
	"./events_activism_white.png": "80bf",
	"./events_allinfo_blue.png": "ae84",
	"./events_allinfo_gray.png": "0d26",
	"./events_assault_black.png": "df60",
	"./events_assault_blue.png": "eb12",
	"./events_assault_white.png": "f870",
	"./events_attempt_black.png": "c7a3",
	"./events_attempt_blue.png": "2529",
	"./events_attempt_white.png": "b720",
	"./events_big.png": "fa0b",
	"./events_conflict_black.png": "9b3f",
	"./events_conflict_blue.png": "885f",
	"./events_conflict_white.png": "e08a",
	"./events_coup_black.png": "b044",
	"./events_coup_blue.png": "663f",
	"./events_coup_white.png": "b207",
	"./events_crime_black.png": "b8c3",
	"./events_crime_blue.png": "eadb",
	"./events_crime_white.png": "546f",
	"./events_disasters_black.png": "3a41",
	"./events_disasters_blue.png": "9434",
	"./events_disasters_white.png": "d044",
	"./events_election_black.png": "219d",
	"./events_election_blue.png": "24e7",
	"./events_election_white.png": "0c91",
	"./events_general_black.png": "183a",
	"./events_general_blue.png": "3106",
	"./events_general_white.png": "fd67",
	"./events_health_black.png": "8454",
	"./events_health_blue.png": "4c45",
	"./events_health_white.png": "006c",
	"./events_hijack_black.png": "4483",
	"./events_hijack_blue.png": "45a9",
	"./events_hijack_white.png": "9ce1",
	"./events_insult_black.png": "1960",
	"./events_insult_blue.png": "5be9",
	"./events_insult_white.png": "94be",
	"./events_kidnap_black.png": "275a",
	"./events_kidnap_blue.png": "a0df",
	"./events_kidnap_white.png": "80cb",
	"./events_maritime_terrorism_black.png": "40d7",
	"./events_maritime_terrorism_blue.png": "811e",
	"./events_maritime_terrorism_white.png": "9807",
	"./events_political_terrorism_black.png": "8ce2",
	"./events_political_terrorism_blue.png": "0a7b",
	"./events_political_terrorism_white.png": "578c",
	"./events_robbery_black.png": "7796",
	"./events_robbery_blue.png": "2c03",
	"./events_robbery_white.png": "ca8e",
	"./events_state_action_black.png": "0a39",
	"./events_state_action_blue.png": "b2c0",
	"./events_state_action_white.png": "9243",
	"./events_suspicious_activity_black.png": "c6bb",
	"./events_suspicious_activity_blue.png": "b867",
	"./events_suspicious_activity_white.png": "e8d8",
	"./events_terrorism_black.png": "c60a",
	"./events_terrorism_blue.png": "fad1",
	"./events_terrorism_white.png": "f1e4",
	"./events_theft_black.png": "50e4",
	"./events_theft_blue.png": "4155",
	"./events_theft_white.png": "c384",
	"./events_threat_black.png": "9e29",
	"./events_threat_blue.png": "576b",
	"./events_threat_white.png": "42b5",
	"./events_toc_black.png": "ee5f",
	"./events_toc_blue.png": "b10b",
	"./events_toc_white.png": "3358",
	"./events_transportation_black.png": "fc96",
	"./events_transportation_blue.png": "97d4",
	"./events_transportation_white.png": "3395",
	"./events_travel_black.png": "3ad2",
	"./events_travel_blue.png": "851a",
	"./events_travel_white.png": "890e",
	"./events_unrest_black.png": "9185",
	"./events_unrest_blue.png": "5396",
	"./events_unrest_white.png": "faa5",
	"./events_war_black.png": "9f88",
	"./events_war_blue.png": "d0e4",
	"./events_war_white.png": "276c",
	"./flood.png": "fa8b",
	"./hotspots.png": "8ba9",
	"./hotspots_big.png": "fd7b",
	"./hotspots_big_selected.png": "e77f",
	"./hotspots_covid.png": "527f",
	"./hotspots_negative.png": "96b7",
	"./hotspots_neutral.png": "d5e6",
	"./hotspots_positive.png": "0bf5",
	"./hotspots_white.png": "a1c6",
	"./influence_economic_black.png": "1753",
	"./influence_economic_white.png": "5816",
	"./influence_information_black.png": "9e26",
	"./influence_information_white.png": "06ee",
	"./influence_infrastructure_black.png": "645a",
	"./influence_infrastructure_white.png": "f317",
	"./influence_military_black.png": "3769",
	"./influence_military_white.png": "a531",
	"./influence_political_black.png": "eea7",
	"./influence_political_white.png": "53a9",
	"./influence_social_black.png": "fbf8",
	"./influence_social_white.png": "4ae5",
	"./influencer_china.png": "8af9",
	"./info_viewer_black.png": "c5ca",
	"./info_viewer_white.png": "d9be",
	"./isos-mini.png": "8f65",
	"./isosTravelTracker/menu_travel_tracker_black.png": "4d07",
	"./isosTravelTracker/menu_travel_tracker_white.png": "88df",
	"./language.png": "b20f",
	"./language_black.png": "d05d",
	"./locations.png": "4b13",
	"./map_clear_events_ai_icons_blue.png": "ce5b",
	"./map_clear_events_ai_icons_white.png": "079b",
	"./map_distance.png": "7701",
	"./map_location_search.png": "a844",
	"./map_settings_black.png": "f8a0",
	"./map_settings_white.png": "f9d6",
	"./menu_alerts_black.png": "9c48",
	"./menu_alerts_white.png": "241d",
	"./menu_assets_black.png": "0993",
	"./menu_assets_white.png": "9430",
	"./menu_collaboration_black.png": "a024",
	"./menu_collaboration_white.png": "42bf",
	"./menu_comms_black.png": "9276",
	"./menu_comms_white.png": "5f9d",
	"./menu_cyber_black.png": "4907",
	"./menu_cyber_white.png": "129c",
	"./menu_dashboard_black.png": "8170",
	"./menu_dashboard_white.png": "38c9",
	"./menu_esri_black.png": "f9c5",
	"./menu_esri_white.png": "6639",
	"./menu_events_black.png": "b5e3",
	"./menu_events_white.png": "96fd",
	"./menu_global_issues_black.png": "3ab8",
	"./menu_global_issues_white.png": "23ba",
	"./menu_globe_black.png": "c344",
	"./menu_globe_white.png": "a4fa",
	"./menu_home_black.png": "9015",
	"./menu_home_white.png": "0421",
	"./menu_hotspots_black.png": "adc3",
	"./menu_hotspots_white.png": "3a86",
	"./menu_influences_black.png": "1ba0",
	"./menu_influences_white.png": "a935",
	"./menu_info_black.png": "c81e",
	"./menu_info_white.png": "9c1c",
	"./menu_latest_black.png": "9ef7",
	"./menu_latest_white.png": "42a3",
	"./menu_map_controls_black.png": "b0e0",
	"./menu_map_controls_white.png": "b4c6",
	"./menu_media_black.png": "9638a",
	"./menu_media_white.png": "db92",
	"./menu_methodology_black.png": "46eb",
	"./menu_methodology_white.png": "9c47",
	"./menu_monitor_black.png": "2c06",
	"./menu_monitor_white.png": "c7e9",
	"./menu_my_incidents_black.png": "103d",
	"./menu_my_incidents_white.png": "4932",
	"./menu_notifications_black.png": "05fa",
	"./menu_notifications_white.png": "2be5",
	"./menu_places_black.png": "bdeb",
	"./menu_places_white.png": "a883",
	"./menu_power_outage_black.png": "9633",
	"./menu_power_outage_white.png": "b6ee",
	"./menu_profile_black.png": "b188",
	"./menu_profile_white.png": "e599",
	"./menu_report_black.png": "2322",
	"./menu_report_white.png": "6fee",
	"./menu_reporting_pane_black.png": "59ee",
	"./menu_reporting_pane_white.png": "ba2b",
	"./menu_resources_black.png": "71d3",
	"./menu_resources_white.png": "4ec7",
	"./menu_search_black.png": "21f7",
	"./menu_search_white.png": "eeb9",
	"./menu_signout_white.png": "49322",
	"./menu_stability_black.png": "9473",
	"./menu_stability_white.png": "79a8",
	"./myIncidents/ban.png": "4ad2",
	"./myIncidents/bolt.png": "3218",
	"./myIncidents/bug.png": "53ea",
	"./myIncidents/car.png": "9097",
	"./myIncidents/conflict.png": "f25e",
	"./myIncidents/crime.png": "135f",
	"./myIncidents/crosshair.png": "5bab",
	"./myIncidents/crowd.png": "8377",
	"./myIncidents/diamond.png": "b1d6",
	"./myIncidents/disasters.png": "89c7",
	"./myIncidents/fireExtinguisher.png": "92c7",
	"./myIncidents/flag.png": "7c3f",
	"./myIncidents/health.png": "f62f",
	"./myIncidents/info.png": "22f0",
	"./myIncidents/lock.png": "8f8d",
	"./myIncidents/medkit.png": "f004",
	"./myIncidents/question.png": "fc64",
	"./myIncidents/road.png": "6928",
	"./myIncidents/rocket.png": "7bb7",
	"./myIncidents/snowflake.png": "0765",
	"./myIncidents/sun.png": "6af0",
	"./myIncidents/terrorism.png": "d85b",
	"./myIncidents/times.png": "ea63",
	"./myIncidents/toc.png": "2590",
	"./myIncidents/transportation.png": "0a3e",
	"./myIncidents/travel.png": "d66b",
	"./myIncidents/truck.png": "8126",
	"./myIncidents/unrest.png": "a7f3",
	"./myIncidents/wrench.png": "7209",
	"./news.png": "d892",
	"./news_white.png": "0a22",
	"./places_black.png": "c353",
	"./places_blue.png": "841c6",
	"./places_cyan.png": "b4da",
	"./places_gray.png": "e7d7",
	"./places_green.png": "0775",
	"./places_magenta.png": "35c7",
	"./places_oilrig_blue.png": "0c76",
	"./places_oilrig_green.png": "b54a",
	"./places_oilrig_orange.png": "6abd",
	"./places_oilrig_pink.png": "f576",
	"./places_oilrig_yellow.png": "3d8a",
	"./places_orange.png": "009c",
	"./places_red.png": "f787",
	"./places_white.png": "6e01",
	"./places_yellow.png": "5cb7",
	"./pulse_orange_big.png": "dfd9",
	"./reset_filters.png": "30de",
	"./search.png": "13b1",
	"./social.png": "7be7",
	"./social_white.png": "71bd",
	"./sort.png": "4ae9",
	"./travel.png": "836d",
	"./travel_big.png": "265e",
	"./travel_white.png": "486c",
	"./unrest.png": "69ef",
	"./unrest_white.png": "f6c4",
	"./volcano.png": "d39d",
	"./war.png": "ef8d",
	"./war_white.png": "8540",
	"./water-icon.png": "aaa0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0075";